import React, { useMemo } from 'react';
import { useTranslation } from 'next-i18next';
import PdpProductFeed from '@components/product/pdp-product-feed/pdp-product-feed';
import useHeroPdpSimilarProductsQuery from '@hooks/hero-pdp/use-hero-pdp-similar-products-query';
import useFeatureFlag from '@hooks/use-feature-flags';

const SemPdpSimilarProductsFeed = () => {
  const { t } = useTranslation();
  const similarProductsQuery = useHeroPdpSimilarProductsQuery();
  const similarProducts = useMemo(() => similarProductsQuery.data?.similarProducts ?? [], [similarProductsQuery.data]);
  const productFeedCategory = 'sem_pdp_recommend';
  const { isSemPDP } = useFeatureFlag();

  if (!similarProducts?.length) {
    return null;
  }

  return (
    <div>
      <PdpProductFeed
        products={similarProducts}
        productFeedCategory={productFeedCategory}
        title={t('HERO_PDP.SIMILAR_PRODUCT.TITLE')}
        productCardProps={{
          moduleType: 'similar_products',
          pageType: 'product_page',
          showProductDirectShipping: false,
          showProductExpressDelivery: false,
          // options for small tiles
          cardType: isSemPDP ? 'standard' : 'small',
          disableLikeButton: !isSemPDP,
          showProductLocation: isSemPDP,
          showProductTags: isSemPDP,
        }}
        cta={null}
        testId={`sem_similar_products`}
        disableOnReveal
      />
    </div>
  );
};

export default SemPdpSimilarProductsFeed;
